module.exports = __webpack_public_path__ + "static/media/web_background.beba3cf1.png";